import * as React from "react";
import { CheckPricesProps } from "./typings";
import { CheckPricesFlexModuleResult } from "typings/microserviceModels/check-prices-flex-module";
import { ItemKeyHelper } from "src/components/utility/ItemKeyHelper";
import { Container } from "./component/Container";
import { Deal } from "./component/Deal";
import { withStores } from "stores";
import { observer } from "mobx-react";

const checkPricesKey = new ItemKeyHelper("check-prices");
// TODO the back-end should have control over what is being rendered as a deal. Right now it follows an anti-pattern of sending a whole bunch of data without proper hierarchy:
//  https://github.expedia.biz/Flex/check-prices-flex-module/blob/master/src/main/java/com/expedia/www/check/prices/module/CheckPricesFlexModuleResult.java
const supportedDeals = ["today", "tomorrow", "thisWeekend", "nextWeekend", "bestWeekend"];

export const viewContext = React.createContext<string | undefined>("");
const ViewProvider = viewContext.Provider;

export const CheckPrices = withStores(
  "flexModuleModelStore",
  "context"
)(
  observer((props: CheckPricesProps) => {
    const { context, flexTemplateNode, flexModuleModelStore } = props;
    const { id, options } = flexTemplateNode;
    const model = flexModuleModelStore.getModel(id) as CheckPricesFlexModuleResult | null;

    /* istanbul ignore next */
    if (!model) {
      return null;
    }

    const availableSupportedDeals = supportedDeals.filter((deal) => deal in model);

    const containerProps = {
      title: model.title,
      id,
      fmId: options.fmId,
      fmTitleId: options.fmTitleId,
      view: options.flexComponentView,
      subHeadline: model.subHeadline,
      dataType: model.dataType,
    };

    return (
      <ViewProvider value={options.flexComponentView}>
        <Container {...containerProps}>
          {availableSupportedDeals.map((modelKey) => (
            <Deal key={checkPricesKey.next()} modelKey={modelKey} model={model} context={context} />
          ))}
        </Container>
      </ViewProvider>
    );
  })
);

export default CheckPrices;
